export const buildCssTree = (modules, pages) => {
  return modules.map((module, index) => {
    if (typeof module === "string") {
      return {
        id: index,
        label: module,
        value: "__" + module,
        checked: false,
        children: pages[module]
          ? pages[module].map((page, ind) => {
              return {
                id: index + "_" + ind + "_" + page,
                label: module + ": " + page,
                value: module + "__" + page.toLowerCase(),
                checked: module === "Banners" && page === "View",
                disabled: module === "Banners" && page === "View"
              };
            })
          : null,
      };
    } else {
      return {
        id: index,
        label: Object.keys(module)[0],
        value: "__" + Object.keys(module)[0],
        checked: false,
        children:
          module &&
          module[Object.keys(module)[0]].length
            ? module[Object.keys(module)[0]].reduce((acc, item) => {
                return acc.concat(
                  pages[item]
                    ? pages[item].map((page, ind) => {
                        return {
                          id: index + "_" + ind + "_" + page,
                          label: item + ": " + page,
                          value: item + "__" + page.toLowerCase(),
                          checked: item === "Banners" && page === "View",
                          disabled: item === "Banners" && page === "View"
                        };
                      })
                    : null
                );
              }, [])
            : null,
      };
    }
  });
};